import { render, staticRenderFns } from "./KeptItemsToggle.vue?vue&type=template&id=dd9d34b6&"
import script from "./KeptItemsToggle.vue?vue&type=script&lang=js&"
export * from "./KeptItemsToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/3672/203/Bigtex5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd9d34b6')) {
      api.createRecord('dd9d34b6', component.options)
    } else {
      api.reload('dd9d34b6', component.options)
    }
    module.hot.accept("./KeptItemsToggle.vue?vue&type=template&id=dd9d34b6&", function () {
      api.rerender('dd9d34b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/bigtex/KeptItemsToggle.vue"
export default component.exports